export default [
    {
        id: 11, //Solo Agro
        name: 'Índice de endeudamiento',
        alert: '>= 100',
        unit: '%',
        formula: 'this.form.b.assets.total_current_assets / this.form.b.passives.total_current_passives',
        info:'Flujo de crédito',
        restriction: 'AG'
    },
    {
        id: 12, //Solo Agro
        name: 'Capacidad de pago acumulada',
        alert: '< 150',
        unit: '%',
        formula: 'this.form.b.assets.total_current_assets / this.form.b.passives.total_current_passives',
        info:'Flujo de crédito',
        restriction: 'AG'
    }
    
]
